/**
 * Класс для работы с событиями
 */
export default class EventEmitter {
	/**
	 * Инициализировать EventEmitter
	 */
	constructor() {
		this.listeners = []
	}

	/**
	 * Подписаться на событие
	 * @param {String} name название события
	 * @param {Function} handler обработчик события
	 * @return {void}
	 */
	on(name, handler) {
		this.listeners.push({ name, handler })
	}

	/**
	 * Отписаться от события
	 * @param {String} name название события
	 * @param {Function|null} handler обработчик события
	 * @return {void}
	 */
	off(name, handler = null) {
		if (handler) {
			this.listeners = this.listeners.filter(listener => listener.name !== name || listener.handler !== handler)
		} else {
			this.listeners = this.listeners.filter(listener => listener.name !== name)
		}
	}

	/**
	 * Вызвать событие
	 * @param {String} name название события
	 * @param {*} params параметры для обработчика
	 * @return {Promise<void>}
	 */
	async emit(name, ...params) {
		// Найти подписчиков на события
		const listeners = this.listeners.filter(listener => listener.name === name && typeof listener.handler === "function")

		// Вызвать все подходящие подписчики события
		for (const listener of listeners) {
			await listener.handler(...params)
		}
	}
}
